import {CIRCLE_RADIUS, CIRCLE_STROKE_WIDTH} from "../../layerDefsConfig";
import {gis2QueryUrl} from "../../../utils/urls";

const getLayerDef = (id, type, label = undefined) => {

    return {
        layer: {
            id: id,
            type: "circle",
            paint: {
                "circle-color": "#9E0059",
                "circle-radius": CIRCLE_RADIUS,
                "circle-stroke-width": CIRCLE_STROKE_WIDTH,
                "circle-stroke-color": "#fff",
            },
            layout: {
                visibility: "none",
            },
        },
        source: {
            id: id,
            type: "geojson",
            data: gis2QueryUrl(
                "hsds_experian_shoppoint",
                8,
                {where: `group_name='${type}'`}
            ),
        },
        labels: {
            parent: label ?? type,
        },
        filterBySelectedRegion: true,
        category: "hsds",
        grouping: "hsds-non-retail-poi",
        requiresGis2Token: true,

        popupType: "non-retail-poi",
        popupAttributes: ["name", "group_name", "category_name", "class_name", "address_detail", "street_name", "postcode"],

        info: {}
    }
}

export const hsdsLayerDefsNonRetailPOI = {
    "hsds-non-retail-poi-accomodation-eating-drinking": getLayerDef("hsds-non-retail-poi-accomodation-eating-drinking", "Accommodation, Eating and Drinking", "Accomodation"),
    "hsds-non-retail-poi-attractions": getLayerDef("hsds-non-retail-poi-attractions", "Attractions"),
    "hsds-non-retail-poi-commercial-services": getLayerDef("hsds-non-retail-poi-commercial-services", "Commercial Services"),
    "hsds-non-retail-poi-education-and-health": getLayerDef("hsds-non-retail-poi-education-and-health", "Education and Health"),
    "hsds-non-retail-poi-manufacturing-and-production": getLayerDef("hsds-non-retail-poi-manufacturing-and-production", "Manufacturing and Production"),
    "hsds-non-retail-poi-public-infrastructure": getLayerDef("hsds-non-retail-poi-public-infrastructure", "Public Infrastructure"),
    //   "hsds-non-retail-poi-retail": getLayerDef("hsds-non-retail-poi-retail", "Retail"),
    "hsds-non-retail-poi-sport-and-entertainment": getLayerDef("hsds-non-retail-poi-sport-and-entertainment", "Sport and Entertainment"),
    "hsds-non-retail-poi-transport": getLayerDef("hsds-non-retail-poi-transport", "Transport"),
}